/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2
 */

export const ActionComponentTypename = 'com.hubspot.ai.agent.models.core.ActionComponent';
export const ActionComponentDiscriminant = 'ACTION';
export const ActionComponentDiscriminantKey = 'type';
export const AgentComponentTypename = 'com.hubspot.ai.agent.models.core.AgentComponent';
export const AgentComponentDiscriminant = 'AGENT';
export const AgentComponentDiscriminantKey = 'type';
export const AgentInputDiscriminantKey = '@type';
export const AgentTemplateComponentTypename = 'com.hubspot.ai.agent.models.core.AgentTemplateComponent';
export const AgentTemplateComponentDiscriminant = 'AGENT_TEMPLATE';
export const AgentTemplateComponentDiscriminantKey = 'type';
export const AviatorAgentComponentTypename = 'com.hubspot.ai.agent.models.core.AviatorAgentComponent';
export const AviatorAgentComponentDiscriminant = 'AVIATOR_SUBAGENT';
export const AviatorAgentComponentDiscriminantKey = 'type';
export const BooleanAgentInputTypename = 'com.hubspot.ai.agent.models.core.BooleanAgentInput';
export const BooleanAgentInputDiscriminant = 'boolean';
export const BooleanAgentInputDiscriminantKey = '@type';
export const BuiltInToolComponentTypename = 'com.hubspot.ai.agent.models.core.BuiltInToolComponent';
export const BuiltInToolComponentDiscriminant = 'BUILT_IN';
export const BuiltInToolComponentDiscriminantKey = 'type';
export const ChirpRpcComponentTypename = 'com.hubspot.ai.agent.models.core.ChirpRpcComponent';
export const ChirpRpcComponentDiscriminant = 'CHIRP_RPC';
export const ChirpRpcComponentDiscriminantKey = 'type';
export const ChirpToolBundleComponentTypename = 'com.hubspot.ai.agent.models.core.ChirpToolBundleComponent';
export const ChirpToolBundleComponentDiscriminant = 'CHIRP_TOOL_BUNDLE';
export const ChirpToolBundleComponentDiscriminantKey = 'type';
export const ComponentV2DiscriminantKey = 'type';
export const ConnectionDetailDiscriminantKey = 'type';
export const CreatedFromDiscriminantKey = 'origin';
export const CrmCardConnectionDataTypename = 'com.hubspot.ai.agent.models.core.CrmCardConnectionData';
export const CrmCardConnectionDataDiscriminant = 'CRM_CARD';
export const CrmCardConnectionDataDiscriminantKey = 'type';
export const CrmObjectCoordinatesAgentInputTypename = 'com.hubspot.ai.agent.models.core.CrmObjectCoordinatesAgentInput';
export const CrmObjectCoordinatesAgentInputDiscriminant = 'object';
export const CrmObjectCoordinatesAgentInputDiscriminantKey = '@type';
export const FileAgentInputTypename = 'com.hubspot.ai.agent.models.core.FileAgentInput';
export const FileAgentInputDiscriminant = 'file';
export const FileAgentInputDiscriminantKey = '@type';
export const FilesAgentInputTypename = 'com.hubspot.ai.agent.models.core.FilesAgentInput';
export const FilesAgentInputDiscriminant = 'files';
export const FilesAgentInputDiscriminantKey = '@type';
export const HookComponentTypename = 'com.hubspot.ai.agent.models.core.HookComponent';
export const HookComponentDiscriminant = 'HOOK';
export const HookComponentDiscriminantKey = 'type';
export const KnowledgeBoxComponentTypename = 'com.hubspot.ai.agent.models.core.KnowledgeBoxComponent';
export const KnowledgeBoxComponentDiscriminant = 'KNOWLEDGE_BOX';
export const KnowledgeBoxComponentDiscriminantKey = 'type';
export const ListAgentInputTypename = 'com.hubspot.ai.agent.models.core.ListAgentInput';
export const ListAgentInputDiscriminant = 'list';
export const ListAgentInputDiscriminantKey = '@type';
export const MapAgentInputTypename = 'com.hubspot.ai.agent.models.core.MapAgentInput';
export const MapAgentInputDiscriminant = 'map';
export const MapAgentInputDiscriminantKey = '@type';
export const McpServerComponentTypename = 'com.hubspot.ai.agent.models.core.McpServerComponent';
export const McpServerComponentDiscriminant = 'MCP_SERVER';
export const McpServerComponentDiscriminantKey = 'type';
export const McpServerV2ComponentTypename = 'com.hubspot.ai.agent.models.core.McpServerV2Component';
export const McpServerV2ComponentDiscriminant = 'MCP_SERVER_V2';
export const McpServerV2ComponentDiscriminantKey = 'type';
export const NullAgentInputTypename = 'com.hubspot.ai.agent.models.core.NullAgentInput';
export const NullAgentInputDiscriminant = 'null';
export const NullAgentInputDiscriminantKey = '@type';
export const NumberAgentInputTypename = 'com.hubspot.ai.agent.models.core.NumberAgentInput';
export const NumberAgentInputDiscriminant = 'number';
export const NumberAgentInputDiscriminantKey = '@type';
export const PortabilityCreatedFromTypename = 'com.hubspot.ai.agent.models.core.PortabilityCreatedFrom';
export const PortabilityCreatedFromDiscriminant = 'PORTABILITY';
export const PortabilityCreatedFromDiscriminantKey = 'origin';
export const RecommendationCreatedFromTypename = 'com.hubspot.ai.agent.models.core.RecommendationCreatedFrom';
export const RecommendationCreatedFromDiscriminant = 'RECOMMENDATION';
export const RecommendationCreatedFromDiscriminantKey = 'origin';
export const SkillComponentTypename = 'com.hubspot.ai.agent.models.core.SkillComponent';
export const SkillComponentDiscriminant = 'SKILL';
export const SkillComponentDiscriminantKey = 'type';
export const StringAgentInputTypename = 'com.hubspot.ai.agent.models.core.StringAgentInput';
export const StringAgentInputDiscriminant = 'string';
export const StringAgentInputDiscriminantKey = '@type';
export const WebhookComponentTypename = 'com.hubspot.ai.agent.models.core.WebhookComponent';
export const WebhookComponentDiscriminant = 'WEBHOOK';
export const WebhookComponentDiscriminantKey = 'type';
export const WorkflowConnectionDataTypename = 'com.hubspot.ai.agent.models.core.WorkflowConnectionData';
export const WorkflowConnectionDataDiscriminant = 'WORKFLOW';
export const WorkflowConnectionDataDiscriminantKey = 'type';

/**
 *  Request to update the "metadata" (toolbar) fields of an agent instance: name, description, and
 *  icon. Unlike {@link PatchAgentInstanceRequestIF}, updating these fields does not create a new
 *  snapshot/version, since they do not change the agent's behavior.
 */

/**
 *  Response for {@link UpdateAgentMetadataRequestIF}. Returns only the updated instance, since a
 *  metadata edit does not change trigger flows, permissions, or the active snapshot (the snapshot id
 *  is still available via {@link AgentInstanceV2#getSnapshotId()}).
 */

/**
 *  Represents a validation error for a specific component (action, knowledge box, etc.).
 *  This structured format allows the frontend to construct user-facing error messages.
 */

export const BooleanFieldValueTypename = 'com.hubspot.chirp.ext.models.BooleanFieldValue';
export const BooleanFieldValueDiscriminant = 'boolean';
export const BooleanFieldValueDiscriminantKey = '@type';
export const DoubleFieldValueTypename = 'com.hubspot.chirp.ext.models.DoubleFieldValue';
export const DoubleFieldValueDiscriminant = 'double';
export const DoubleFieldValueDiscriminantKey = '@type';
export const FieldValueDiscriminantKey = '@type';
export const FloatFieldValueTypename = 'com.hubspot.chirp.ext.models.FloatFieldValue';
export const FloatFieldValueDiscriminant = 'float';
export const FloatFieldValueDiscriminantKey = '@type';
export const IntFieldValueTypename = 'com.hubspot.chirp.ext.models.IntFieldValue';
export const IntFieldValueDiscriminant = 'integer';
export const IntFieldValueDiscriminantKey = '@type';
export const ListFieldValueTypename = 'com.hubspot.chirp.ext.models.ListFieldValue';
export const ListFieldValueDiscriminant = 'list';
export const ListFieldValueDiscriminantKey = '@type';
export const LongFieldValueTypename = 'com.hubspot.chirp.ext.models.LongFieldValue';
export const LongFieldValueDiscriminant = 'long';
export const LongFieldValueDiscriminantKey = '@type';
export const MapFieldValueTypename = 'com.hubspot.chirp.ext.models.MapFieldValue';
export const MapFieldValueDiscriminant = 'map';
export const MapFieldValueDiscriminantKey = '@type';
export const NullFieldValueTypename = 'com.hubspot.chirp.ext.models.NullFieldValue';
export const NullFieldValueDiscriminant = 'null';
export const NullFieldValueDiscriminantKey = '@type';
export const StringFieldValueTypename = 'com.hubspot.chirp.ext.models.StringFieldValue';
export const StringFieldValueDiscriminant = 'string';
export const StringFieldValueDiscriminantKey = '@type';
export const getAgentInstanceRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getAgentInstance',
  auth: 'app',
  fingerprint: 'luxHuQpJJYjAe847eiDfZBQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAgentInstancesByIDsRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getAgentInstancesByIDs',
  auth: 'app',
  fingerprint: 'v_Hi8JpYU3hA8EcmmhOWChQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAgentInstancesMetadataByIDsRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getAgentInstancesMetadataByIDs',
  auth: 'app',
  fingerprint: 'KkCtLaXxTCouhohdCRceWhQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAgentInstancesWithSnapshotsRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getAgentInstancesWithSnapshots',
  auth: 'app',
  fingerprint: '9QKX_6KF_GHWnQ9PK78kRRQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAgentInstancesByWorkflowIdRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getAgentInstancesByWorkflowId',
  auth: 'app',
  fingerprint: 'jhR4yXLMTW1sm9krVkQABhQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getActiveAgentInstancesRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getActiveAgentInstances',
  auth: 'app',
  fingerprint: 'tt8k1TqizUbmOEqLuqtinRQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listAgentInstancesRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'listAgentInstances',
  auth: 'app',
  fingerprint: 'Hn4UORB9gPjmOEqLuqtinRQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const searchAgentInstancesRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'searchAgentInstances',
  auth: 'app',
  fingerprint: 'YA5lK2Rcr5bmOEqLuqtinRQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createAgentInstanceRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'createAgentInstance',
  auth: 'app',
  fingerprint: '2Ji3nPQHok_i2S95-Jfn8BQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateAgentInstanceRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'updateAgentInstance',
  auth: 'app',
  fingerprint: 'M_LbLyIuKDnAe847eiDfZBQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateAgentInstanceV2Rpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'updateAgentInstanceV2',
  auth: 'app',
  fingerprint: 'M_LbLyIuKDnAe847eiDfZBQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateAgentInstanceV3Rpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'updateAgentInstanceV3',
  auth: 'app',
  fingerprint: 'FvIyApFs2CXAe847eiDfZBQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const patchAgentInstanceRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'patchAgentInstance',
  auth: 'app',
  fingerprint: 'JgqknsMAtg_Ae847eiDfZBQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateAgentMetadataRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'updateAgentMetadata',
  auth: 'app',
  fingerprint: '61HkWFDvVby-NDbZ5FFCyxQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateAgentAvailabilityRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'updateAgentAvailability',
  auth: 'app',
  fingerprint: 'Ogp6B8VUuGPAe847eiDfZBQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const resetToLatestTemplateRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'resetToLatestTemplate',
  auth: 'app',
  fingerprint: 'Im2kC-4d0BvmgeKWNrd9ChQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const softDeleteAgentInstanceRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'softDeleteAgentInstance',
  auth: 'app',
  fingerprint: 'luxHuQpJJYhzxnLXxOhAlxQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const softDeleteAgentInstanceV2Rpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'softDeleteAgentInstanceV2',
  auth: 'app',
  fingerprint: 'bquNPpxFM9hzxnLXxOhAlxQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createInstanceFromTemplateRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'createInstanceFromTemplate',
  auth: 'app',
  fingerprint: '6TQD2mYKly_hBsPtnU5wdxQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createInstanceFromTemplateByGlobalIdRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'createInstanceFromTemplateByGlobalId',
  auth: 'app',
  fingerprint: 'ZA_kNe5-Cz_hBsPtnU5wdxQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const cloneAgentInstanceRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'cloneAgentInstance',
  auth: 'app',
  fingerprint: 'IDPzP_Tubm3hBsPtnU5wdxQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const cloneAgentsForFlowRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'cloneAgentsForFlow',
  auth: 'app',
  fingerprint: 'LVwvv72TyJmB427QAG27wRQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInstancesByTemplateIdsRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getInstancesByTemplateIds',
  auth: 'app',
  fingerprint: 'Bao0fja8a37EJCZoswV7nhQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInstancesByGlobalIdRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getInstancesByGlobalId',
  auth: 'app',
  fingerprint: 'yPtD4Qwpkj8q4nFlIQCByxQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateAgentInstanceOwnerRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'updateAgentInstanceOwner',
  auth: 'app',
  fingerprint: 'biKggbtMJGFzxnLXxOhAlxQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateAgentInstanceFromSnapshotRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'updateAgentInstanceFromSnapshot',
  auth: 'app',
  fingerprint: 'vxmtmtyT79zAe847eiDfZBQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const cloneInstanceFromSnapshotRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'cloneInstanceFromSnapshot',
  auth: 'app',
  fingerprint: 'jfr4Elt4T0XhBsPtnU5wdxQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const validateAgentInstanceReadinessRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'validateAgentInstanceReadiness',
  auth: 'app',
  fingerprint: 'jamLS5AjeEFHKNNd4MLGeBQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const validateAgentInstanceReadinessV2Rpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'validateAgentInstanceReadinessV2',
  auth: 'app',
  fingerprint: '_y3TSpR__PPlnnLyhTfIORQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const bulkValidateAgentInstancesReadinessRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'bulkValidateAgentInstancesReadiness',
  auth: 'app',
  fingerprint: 'ate6fB_EofplU4ciiiItdhQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const bulkCreateAgentInstancesRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'bulkCreateAgentInstances',
  auth: 'app',
  fingerprint: 'NwDUdol9Kl_meXFNKfYvsBQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const bulkCreateAgentInstancesByKeyRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'bulkCreateAgentInstancesByKey',
  auth: 'app',
  fingerprint: 'ldHhYkreRlGCGWJXiMryehQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const bulkSoftDeleteAgentInstancesRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'bulkSoftDeleteAgentInstances',
  auth: 'app',
  fingerprint: 'lQSah62WeHRlIE2fHG1QwxQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAgentConnectionsRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getAgentConnections',
  auth: 'app',
  fingerprint: 'L5P9kdUDyVu5RJ9mIMBXkRQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getGlobalAgentConnectionsRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getGlobalAgentConnections',
  auth: 'app',
  fingerprint: 'pTxOjWy54EOXYexQDk_6aBQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listAgentInstancesWithInvocabilityRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'listAgentInstancesWithInvocability',
  auth: 'app',
  fingerprint: 's6XxJrA_0IeM31wOQ5Z5OxQxCBo1jpIH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};